<template>
  <div
    v-if="memberShow"
    id="PersonalInformation2"
    class="well"
    style="padding: 0 1em"
  >
    <div class="course_title">學生篇學籍基本資料</div>

    <div class="form-group">
      <table v-if="inputData != null" class="table" style="width: auto; align: left">
        <tbody>
          <tr>
            <td colspan="4" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。<br>
                (學校幾乎都用email跟手機通知大家因此請同學提供有在使用的email及手機)
                </span>
            </td>
          </tr>
          <tr  align="left" >
            <td>班 級</td>
            <td>
              <div class="input-group-text">
                {{ inputData.clsnm }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr  align="left">
            <td>學 號</td>
            <td>
              <div class="input-group-text">
                {{ inputData.sid }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>姓 名</td>
            <td>
              <div class="input-group-text">
                {{ inputData.name }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>手 機</td>
            <td>
              <div class="input-group-text">
                {{ inputData.mobiphone }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>身分證號碼</td>
            <td>
              <div class="input-group-text">
                {{ inputData.idno }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>性 別</td>
            <td>
              <div class="input-group-text">
                {{ inputData.sex == 1 ? "男" : "女" }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>戶籍住址</td>
            <td>
              <div class="input-group-text">
                {{ inputData.hmadd1 }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td>eMail</td>
            <td>
              <div class="input-group-text">
                {{ inputData.eMail }}
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>

          <tr align="left">
            <td>獎金匯款資料</td>
            <td>請提供本人帳戶</td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>銀行名稱</td>
            <td>
              <input
                type="text"
                class="form-control"
                v-model="queryInfo.postname"
                placeholder="銀行名稱"
                required
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>分行名稱</td>
            <td>
              <b-form-input
                v-model="queryInfo.postsubName"
                placeholder="分行名稱"
              >
              </b-form-input>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>分行代碼(必填7碼)</td>
            <td>
              <input
                type="Number"
                class="form-control"
                v-model="queryInfo.postsubID"
                placeholder="分行代碼(必填7碼)"
                pattern="/^-?\d+$/"
                onKeyPress="if(this.value.length==7) return false;"
                required
              />

              <a
                type="button"
                href="https://www.fisc.com.tw/TC/Service?Caid=51254999-5d15-4ddf-8e54-4b2cdb2a8399&CaStyleId=16"
                target="_blank"
                class="btn btn-outline-success"
                >分行代碼查詢</a
              >
              <br />
              (中華郵政存簿儲金代碼一律填寫7000021，銀行碼為總代號+分支代號，例如第一銀行台中分行請填0074016)
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>銀行帳號</td>
            <td>
              <input
                type="Number"
                class="form-control"
                v-model="queryInfo.postno"
                placeholder="銀行帳號"
                pattern="/^-?\d+$/"
                required
              /><br />
              (郵局帳戶請填局號+帳號)(請勿夾帶任何符號 例如:「+,-,*,/」或空格)
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr align="left">
            <td><span style="color: #f00">＊</span>金融帳戶封面影本</td>

            <td>
              <div>
                <b-form-file
                  class="mb-2"
                  ref="file-input"
                  :no-drop="true"
                  :no-traverse="true"
                  v-model="file"
                  @input="fileChange(0)"
                  placeholder="上傳金融帳戶封面影本(郵局或銀行皆可)"
                  accept="image/jpeg, image/png, image/gif, application/pdf"
                ></b-form-file>

                <span v-if="queryInfo.RowId != undefined">
                  <a
                    :href="
                      './WebApi/Common/GetDocumentFile2/' + queryInfo.RowId
                    "
                    target="_blank"
                  >
                    <img src="@/assets/images/disk.png" />
                  </a>
                  {{ queryInfo.RowId != undefined ? queryInfo.name : "" }}
                </span>
              </div>
            </td>
            <td></td>
            <td></td>
          </tr>

          <tr style="text-align: center">
            <td></td>

            <td>
              <button
                class="btn active bg-info text-white rounded"
                @click="addMember()"
              >
                送出資料
              </button>
            </td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as tools from '../tool'

export default {
  name: 'PersonalInformation2',
  props: ['sid'],
  data () {
    return {
      file1: null,
      file2: null,
      // memberShow: this.$store.state.user2,
      memberShow: false,
      inputData2: this.$store.state.inputData,
      inputData: null,
      mode: false,
      // file: [{ name: "", RowId: "" }],
      file: null,
      total: 0,
      isIE: false,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        //   postid: "", //銀行總代號
        id: '',
        stdID: '',
        postname: '', // 銀行名稱
        postno: '', // 銀行帳號
        postsubID: '', // 分行代碼(必填7碼)前三碼是銀行總代號
        postsubName: '', // 分行名稱
        Info: [],
        sid: '',
        RowId: '',
        name: ''
      }
    }
  },
  computed: {
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  methods: {
    CaseSelect (id) {
      this.$emit('CaseSelect', id)
    },
    isEmpty (data) {
      return !(data != null && data != undefined && data.length > 0)
    },
    checkSaveData () {
      var msg = ''

      if (this.isEmpty(this.inputData.mobiphone)) {
        msg = '請到學生篇(https://nmsd.ncut.edu.tw/wbcmss/Auth/Login)輸入聯絡手機資訊'
      } else if (this.isEmpty(this.queryInfo.postname)) {
        msg = '請輸入銀行名稱'
      } else if (this.isEmpty(this.queryInfo.postsubName)) {
        msg = '請輸入分行名稱'
      } else if (this.isEmpty(this.queryInfo.postsubID)) {
        msg = '請輸入分行代碼(必填7碼)前三碼是銀行總代號'
      } else if (this.isEmpty(this.queryInfo.postno)) {
        msg = '請輸入銀行帳號'
      } else if (this.isEmpty(this.file.name)) {
        msg = '請上傳金融帳戶封面影本'
      }
      return msg
    },

    fileChange (index) {
      //  var vm = this;
      this.formData = new FormData()

      if (index == 0) {
        this.formData.delete('header')
        this.formData.append('header', this.file)
      }

      this.$http
        .post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index == 0) {
              // this.file = response.data[0];

              this.queryInfo.Info = response.data
            }
          } else {
            tools.showAlert(vm, 'danger', '上傳檔案失敗，請重新上傳' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗，請重新上傳' + error)
        })
    },
    addMember: function () {
      var msg = this.checkSaveData()
      if (msg.length != 0) {
        alert(msg)
        return null
      }

      const vm = this
      vm.queryInfo.sid = vm.inputData2.usrData.id
      if (vm.mode == false) {
        console.log(vm.queryInfo)
        // 新增
        this.$http
          .put('./WebApi/EconomicDisadvantage/SetReportsStudentBank/', vm.queryInfo)
          .then((response) => {
            if (response.data > 0) {
              alert('新增上傳成功')
              this.CaseSelect(2)
              // this.getBankData();
            } else if (response.data == 0) alert('已有資料了')
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      } // 更新
      else {
        console.log(vm.queryInfo)
        this.$http
          .put(
            './WebApi/EconomicDisadvantage/UpdateReportsStudentBank/',
            vm.queryInfo
          )
          .then((response) => {
            if (response.data > 0) {
              alert('更新上傳成功')
              this.CaseSelect(2)
            } else if (response.data == 0) alert('更新失敗')
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      }
    },
    isNullOrEmpty (s) {
      return s == null || s === ''
    },
    getBankData () {
      const vm = this
      if (!vm.isNullOrEmpty(vm._props.sid)) {
        vm.memberShow = true
        vm.queryInfo.sid = vm._props.sid
      } else if (!vm.isNullOrEmpty(vm.inputData2.usrData.id)) { vm.queryInfo.sid = vm.inputData2.usrData.id }

      this.$http
        .get('./WebApi/EconomicDisadvantage/GetBankData/'.concat(vm.queryInfo.sid))
        .then((response) => {
          if (response.data != null) {
            vm.queryInfo.id = response.data.id
            vm.queryInfo.stdID = response.data.id
            vm.queryInfo.postname = response.data.postname
            vm.queryInfo.postno = response.data.postno
            vm.queryInfo.postsubID = response.data.postsubID
            vm.queryInfo.postsubName = response.data.postsubName
            if (response.data.attachInfoString != null) {
              const jsonArr = JSON.parse(response.data.attachInfoString)
              vm.queryInfo.name = jsonArr.FileNm
              vm.queryInfo.RowId = jsonArr.RowId
              vm.mode = true
            }
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    getStudentInfo2: function () {
      var vm = this
      if (!vm.isNullOrEmpty(vm.inputData2)) { var id = vm.inputData2.usrData.id } else { var id = vm._props.sid }

      this.$http
        .get('./WebApi/EconomicDisadvantage/GetStudentInfo2/'.concat(id))
        .then((response) => {
          if (response.data != null) {
            vm.memberShow = true
            vm.inputData = response.data
          }
        })
        .catch(function (error) {
          tools.showAlert(
            vm,
            'danger',
            '對不起, 登入失敗, 請檢查帳號是否輸入正確'
          )
        })
    }
  },
  created () {
    console.log('======created PersonalInformationView =====')
    // this.getBankData();
    this.getStudentInfo2()
  },
  // beforeMount() {
  //   console.log("======beforeMount StdLoginView  =====");
  //   this.getStudentInfo2();
  // },

  mounted () {
    console.log('======mounted StdLoginView  =====')

    this.getBankData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
